// ****************** LOGIN **********************
export const loginURL = `auth/login`;

// ****************** SIGNUP **********************
export const verifyToken = `auth/verifyToken`;

// ****************** MYPROFILE **********************
export const myProfile = `auth/getMyProfile`;
